module.exports = __webpack_public_path__ + "img/9791156331513.3602d65a.jpg";